import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from "vue-gtag";
import Ads from "vue-google-adsense";
import VueCarousel from 'vue-carousel';

Vue.config.devtools = true;
Vue.config.productionTip = false

Vue.use(VueCarousel);

Vue.use(VueGtag, {
  config: { id: "G-X0DBQ3TGXV" }
});

Vue.use(require("vue-script2"));
Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);

router.beforeEach((to, from, next) => {
  const defaultTitle = 'はいしんツールキット | 配信者向け無料ツール集';
  const defaultDescription = 'ライブ配信活動に役立つ無料ツールキット。OBSで使える時計、カウンター、コメント表示など、YouTubeやTwitchの配信者向けツールを提供。';

  document.title = to.meta.title || defaultTitle;

  let descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute('content', to.meta.desc || defaultDescription);
  }
  
  let ogTitleMeta = document.querySelector('meta[property="og:title"]');
  if (ogTitleMeta) {
    ogTitleMeta.setAttribute('content', to.meta.title || defaultTitle);
  }

  let ogDescriptionMeta = document.querySelector('meta[property="og:description"]');
  if (ogDescriptionMeta) {
    ogDescriptionMeta.setAttribute('content', to.meta.desc || defaultDescription);
  }
  
  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
